import { defineRecipe } from '@chakra-ui/react';
import { generateInputRecipe } from './inputRecipe';

export function generateTextAreaRecipe() {
  const inputRecipe = generateInputRecipe();
  return defineRecipe({
    className: 'chakra-textarea',
    ...inputRecipe
  });
}
